import { createAction } from '@reduxjs/toolkit'
import { LoggedUser } from '../../types/user'

export const setLoggedUserData = createAction<LoggedUser>('user/setLoggedUserData')
export const setUserTablePageSize = createAction<string>('user/setUserTablePageSize')
export const logout = createAction<void>('user/logout')
